<div class="insurance-card" [ngClass]="{ selected: isChecked() }">
  <div class="insurance-card__status">
    <span class="badge" [ngClass]="statusClass()">{{ cardData().status }}</span>
  </div>

  <div class="insurance-card__header">
    <input
      type="checkbox"
      [id]="'insurance-' + cardData().id"
      [name]="cardData().title"
      [checked]="isChecked()"
      (change)="onCheckboxChange()"
      class="insurance-card__checkbox"
    />
    <label
      [for]="'insurance-' + cardData().id"
      class="insurance-card__header-title"
    >
      {{ cardData().title }}
    </label>
  </div>

  <div class="insurance-card__body">
    <ul class="insurance-card__info">
      <li class="insurance-card__info-item insurance-card__info-item--plan">
        <span>{{ cardData().plan }}</span>
      </li>
      <li class="insurance-card__info-item insurance-card__info-item--frequency">
        <p>Forma de pago</p>
        <span>{{ cardData().paymentFrequency === 'annual' ? 'Anual' : 'Mensual' }}</span>
      </li>
      <li class="insurance-card__info-item">
        <p>Número de recibo:</p>
        <span>{{ cardData().receiptNumber }}</span>
      </li>
      <li class="insurance-card__info-item">
        <p>Póliza:</p>
        <span>{{ '****' + cardData().policy.slice(4) }}</span>
      </li>
      <li class="insurance-card__info-item">
        <p>Fecha de pago:</p>
        <span>{{ cardData().paymentDate }}</span>
      </li>
      <li class="insurance-card__info-item payment">
        <p>Pago</p>
        <span>{{ cardData().amount }}</span>
      </li>
    </ul>

  </div>

  <div class="insurance-card__footer">
    <button
      type="button"
      [id]="'insurance-card-button-' + cardData().id"
      class="btnPayment"
      [disabled]="!isChecked() || !cardData().isPayable || isPaymentProcessing()"
      (click)="onPayment()"
    > Pagar 
    </button>
  </div>
</div>
